export class TimetableTypes {
  public static types = {
    1: 'Drugo',
    2: 'Naročanje',
    3: 'Delovni čas',
  };
}

export class PostNumbers {
  public static numbers = {
    8341: 'Adlešiči',
    5270: 'Ajdovščina',
    6280: 'Ankaran',
    9253: 'Apače',
    8253: 'Artiče',
    4275: 'Begunje na Gorenjskem',
    1382: 'Begunje pri Cerknici',
    9231: 'Beltinci',
    2234: 'Benedikt',
    2345: 'Bistrica ob Dravi',
    3256: 'Bistrica ob Sotli',
    8259: 'Bizeljsko',
    1223: 'Blagovica',
    8283: 'Blanca',
    4260: 'Bled',
    4273: 'Blejska Dobrava',
    9265: 'Bodonci',
    9222: 'Bogojina',
    4263: 'Bohinjska Bela',
    4264: 'Bohinjska Bistrica',
    4265: 'Bohinjsko jezero',
    1353: 'Borovnica',
    8294: 'Boštanj',
    5230: 'Bovec',
    5295: 'Branik',
    3314: 'Braslovče',
    5223: 'Breginj',
    8280: 'Brestanica',
    2354: 'Bresternica',
    4243: 'Brezje',
    1351: 'Brezovica pri Ljubljani',
    8250: 'Brežice',
    4210: 'Brnik - Aerodrom',
    8321: 'Brusnice',
    3255: 'Buče',
    8276: 'Bučka',
    9261: 'Cankova',
    3000: 'Celje',
    3001: 'Celje - poštni predali',
    4207: 'Cerklje na Gorenjskem',
    8263: 'Cerklje ob Krki',
    1380: 'Cerknica',
    5282: 'Cerkno',
    2236: 'Cerkvenjak',
    2215: 'Ceršak',
    2326: 'Cirkovce',
    2282: 'Cirkulane',
    5273: 'Col',
    8251: 'Čatež ob Savi',
    1413: 'Čemšenik',
    5253: 'Čepovan',
    9232: 'Črenšovci',
    2393: 'Črna na Koroškem',
    6275: 'Črni Kal',
    5274: 'Črni Vrh nad Idrijo',
    5262: 'Črniče',
    8340: 'Črnomelj',
    6271: 'Dekani',
    5210: 'Deskle',
    2253: 'Destrnik',
    6215: 'Divača',
    1233: 'Dob',
    3224: 'Dobje pri Planini',
    8257: 'Dobova',
    1423: 'Dobovec',
    5263: 'Dobravlje',
    3204: 'Dobrna',
    8211: 'Dobrnič',
    1356: 'Dobrova',
    9223: 'Dobrovnik',
    5212: 'Dobrovo v Brdih',
    1431: 'Dol pri Hrastniku',
    1262: 'Dol pri Ljubljani',
    1273: 'Dole pri Litiji',
    1331: 'Dolenja vas',
    8350: 'Dolenjske Toplice',
    1230: 'Domžale',
    2252: 'Dornava',
    5294: 'Dornberk',
    1319: 'Draga',
    8343: 'Dragatuš',
    3222: 'Dramlje',
    2370: 'Dravograd',
    4203: 'Duplje',
    6221: 'Dutovlje',
    8361: 'Dvor',
    2343: 'Fala',
    9208: 'Fokovci',
    2313: 'Fram',
    3213: 'Frankolovo',
    1274: 'Gabrovka',
    8254: 'Globoko',
    5275: 'Godovič',
    4204: 'Golnik',
    3303: 'Gomilsko',
    4224: 'Gorenja vas',
    3263: 'Gorica pri Slivnici',
    2272: 'Gorišnica',
    9250: 'Gornja Radgona',
    3342: 'Gornji Grad',
    4282: 'Gozd Martuljek',
    6272: 'Gračišče',
    9264: 'Grad',
    8332: 'Gradac',
    1384: 'Grahovo',
    5242: 'Grahovo ob Bači',
    5251: 'Grgar',
    3302: 'Griže',
    3231: 'Grobelno',
    1290: 'Grosuplje',
    2288: 'Hajdina',
    8362: 'Hinje',
    2311: 'Hoče',
    9205: 'Hodoš',
    1354: 'Horjul',
    1372: 'Hotedršica',
    1430: 'Hrastnik',
    6225: 'Hruševje',
    4276: 'Hrušica',
    5280: 'Idrija',
    1292: 'Ig',
    6250: 'Ilirska Bistrica',
    6251: 'Ilirska Bistrica-Trnovo',
    1295: 'Ivančna Gorica',
    2259: 'Ivanjkovci',
    1411: 'Izlake',
    6310: 'Izola',
    2222: 'Jakobski Dol',
    2221: 'Jarenina',
    6254: 'Jelšane',
    4270: 'Jesenice',
    8261: 'Jesenice na Dolenjskem',
    3273: 'Jurklošter',
    2223: 'Jurovski Dol',
    2256: 'Juršinci',
    5214: 'Kal nad Kanalom',
    3233: 'Kalobje',
    4246: 'Kamna Gorica',
    2351: 'Kamnica',
    1241: 'Kamnik',
    5213: 'Kanal',
    8258: 'Kapele',
    2362: 'Kapla',
    2325: 'Kidričevo',
    1412: 'Kisovec',
    6253: 'Knežak',
    5222: 'Kobarid',
    9227: 'Kobilje',
    1330: 'Kočevje',
    1338: 'Kočevska Reka',
    2276: 'Kog',
    5211: 'Kojsko',
    6223: 'Komen',
    1218: 'Komenda',
    6000: 'Koper',
    6001: 'Koper - poštni predali',
    8282: 'Koprivnica',
    5296: 'Kostanjevica na Krasu',
    8311: 'Kostanjevica na Krki',
    1336: 'Kostel',
    6256: 'Košana',
    2394: 'Kotlje',
    6240: 'Kozina',
    3260: 'Kozje',
    4000: 'Kranj',
    4001: 'Kranj - poštni predali',
    4280: 'Kranjska Gora',
    1281: 'Kresnice',
    4294: 'Križe',
    9206: 'Križevci',
    9242: 'Križevci pri Ljutomeru',
    1301: 'Krka',
    8296: 'Krmelj',
    4245: 'Kropa',
    8262: 'Krška vas',
    8270: 'Krško',
    9263: 'Kuzma',
    2318: 'Laporje',
    3270: 'Laško',
    1219: 'Laze v Tuhinju',
    2230: 'Lenart v Slovenskih goricah',
    9220: 'Lendava',
    4248: 'Lesce',
    3261: 'Lesično',
    8273: 'Leskovec pri Krškem',
    2372: 'Libeliče',
    2341: 'Limbuš',
    1270: 'Litija',
    3202: 'Ljubečna',
    1000: 'Ljubljana',
    1001: 'Ljubljana - poštni predali',
    1231: 'Ljubljana - Črnuče',
    1261: 'Ljubljana - Dobrunje',
    1260: 'Ljubljana - Polje',
    1210: 'Ljubljana - Šentvid',
    1211: 'Ljubljana - Šmartno',
    3333: 'Ljubno ob Savinji',
    9240: 'Ljutomer',
    3215: 'Loče',
    5231: 'Log pod Mangartom',
    1358: 'Log pri Brezovici',
    1370: 'Logatec',
    1371: 'Logatec',
    1434: 'Loka pri Zidanem Mostu',
    3223: 'Loka pri Žusmu',
    6219: 'Lokev',
    1318: 'Loški Potok',
    2324: 'Lovrenc na Dravskem polju',
    2344: 'Lovrenc na Pohorju',
    3334: 'Luče',
    1225: 'Lukovica',
    9202: 'Mačkovci',
    2322: 'Majšperk',
    2321: 'Makole',
    9243: 'Mala Nedelja',
    2229: 'Malečnik',
    6273: 'Marezige',
    2000: 'Maribor',
    2001: 'Maribor - poštni predali',
    2206: 'Marjeta na Dravskem polju',
    2281: 'Markovci',
    9221: 'Martjanci',
    6242: 'Materija',
    4211: 'Mavčiče',
    1215: 'Medvode',
    1234: 'Mengeš',
    8330: 'Metlika',
    2392: 'Mežica',
    2204: 'Miklavž na Dravskem polju',
    2275: 'Miklavž pri Ormožu',
    5291: 'Miren',
    8233: 'Mirna',
    8216: 'Mirna Peč',
    2382: 'Mislinja',
    4281: 'Mojstrana',
    8230: 'Mokronog',
    1251: 'Moravče',
    9226: 'Moravske Toplice',
    5216: 'Most na Soči',
    1221: 'Motnik',
    3330: 'Mozirje',
    9000: 'Murska Sobota',
    9001: 'Murska Sobota - poštni predali',
    2366: 'Muta',
    4202: 'Naklo',
    3331: 'Nazarje',
    1357: 'Notranje Gorice',
    3203: 'Nova Cerkev',
    5000: 'Nova Gorica',
    5001: 'Nova Gorica - poštni predali',
    1385: 'Nova vas',
    8000: 'Novo mesto',
    8001: 'Novo mesto - poštni predali',
    6243: 'Obrov',
    9233: 'Odranci',
    2317: 'Oplotnica',
    2312: 'Orehova vas',
    2270: 'Ormož',
    1316: 'Ortnek',
    1337: 'Osilnica',
    8222: 'Otočec',
    2361: 'Ožbalt',
    2231: 'Pernica',
    2211: 'Pesnica pri Mariboru',
    9203: 'Petrovci',
    3301: 'Petrovče',
    6330: 'Piran',
    8255: 'Pišece',
    6257: 'Pivka',
    6232: 'Planina',
    3225: 'Planina pri Sevnici',
    6276: 'Pobegi',
    8312: 'Podbočje',
    5243: 'Podbrdo',
    3254: 'Podčetrtek',
    2273: 'Podgorci',
    6216: 'Podgorje',
    2381: 'Podgorje pri Slovenj Gradcu',
    6244: 'Podgrad',
    1414: 'Podkum',
    2286: 'Podlehnik',
    5272: 'Podnanos',
    4244: 'Podnart',
    3241: 'Podplat',
    3257: 'Podsreda',
    2363: 'Podvelka',
    2208: 'Pohorje',
    2257: 'Polenšak',
    1355: 'Polhov Gradec',
    4223: 'Poljane nad Škofjo Loko',
    2319: 'Poljčane',
    1272: 'Polšnik',
    3313: 'Polzela',
    3232: 'Ponikva',
    6320: 'Portorož',
    6230: 'Postojna',
    2331: 'Pragersko',
    3312: 'Prebold',
    4205: 'Preddvor',
    6255: 'Prem',
    1352: 'Preserje',
    6258: 'Prestranek',
    2391: 'Prevalje',
    3262: 'Prevorje',
    1276: 'Primskovo',
    3253: 'Pristava pri Mestinju',
    9207: 'Prosenjakovci',
    5297: 'Prvačina',
    2250: 'Ptuj',
    2323: 'Ptujska Gora',
    9201: 'Puconci',
    2327: 'Rače',
    1433: 'Radeče',
    9252: 'Radenci',
    2360: 'Radlje ob Dravi',
    1235: 'Radomlje',
    4240: 'Radovljica',
    8274: 'Raka',
    1381: 'Rakek',
    4283: 'Rateče - Planica',
    2390: 'Ravne na Koroškem',
    9246: 'Razkrižje',
    3332: 'Rečica ob Savinji',
    5292: 'Renče',
    1310: 'Ribnica',
    2364: 'Ribnica na Pohorju',
    3272: 'Rimske Toplice',
    1314: 'Rob',
    5215: 'Ročinj',
    3250: 'Rogaška Slatina',
    9262: 'Rogašovci',
    3252: 'Rogatec',
    1373: 'Rovte',
    2342: 'Ruše',
    1282: 'Sava',
    6333: 'Sečovlje',
    4227: 'Selca',
    2352: 'Selnica ob Dravi',
    8333: 'Semič',
    8281: 'Senovo',
    6224: 'Senožeče',
    8290: 'Sevnica',
    6210: 'Sežana',
    2214: 'Sladki Vrh',
    5283: 'Slap ob Idrijci',
    2380: 'Slovenj Gradec',
    2310: 'Slovenska Bistrica',
    3210: 'Slovenske Konjice',
    1216: 'Smlednik',
    5232: 'Soča',
    1317: 'Sodražica',
    3335: 'Solčava',
    5250: 'Solkan',
    4229: 'Sorica',
    4225: 'Sovodenj',
    5281: 'Spodnja Idrija',
    2241: 'Spodnji Duplek',
    9245: 'Spodnji Ivanjci',
    2277: 'Središče ob Dravi',
    4267: 'Srednja vas v Bohinju',
    8256: 'Sromlje',
    5224: 'Srpenica',
    1242: 'Stahovica',
    1332: 'Stara Cerkev',
    8342: 'Stari trg ob Kolpi',
    1386: 'Stari trg pri Ložu',
    2205: 'Starše',
    2289: 'Stoperce',
    8322: 'Stopiče',
    3206: 'Stranice',
    8351: 'Straža',
    1313: 'Struge',
    8293: 'Studenec',
    8331: 'Suhor',
    2233: 'Sv. Ana v Slovenskih goricah',
    2235: 'Sv. Trojica v Slovenskih goricah',
    2353: 'Sveti Duh na Ostrem Vrhu',
    9244: 'Sveti Jurij ob Ščavnici',
    3264: 'Sveti Štefan',
    2258: 'Sveti Tomaž',
    9204: 'Šalovci',
    5261: 'Šempas',
    5290: 'Šempeter pri Gorici',
    3311: 'Šempeter v Savinjski dolini',
    4208: 'Šenčur',
    2212: 'Šentilj v Slovenskih goricah',
    8297: 'Šentjanž',
    2373: 'Šentjanž pri Dravogradu',
    8310: 'Šentjernej',
    3230: 'Šentjur',
    3271: 'Šentrupert',
    8232: 'Šentrupert',
    1296: 'Šentvid pri Stični',
    8275: 'Škocjan',
    6281: 'Škofije',
    4220: 'Škofja Loka',
    3211: 'Škofja vas',
    1291: 'Škofljica',
    6274: 'Šmarje',
    1293: 'Šmarje - Sap',
    3240: 'Šmarje pri Jelšah',
    8220: 'Šmarješke Toplice',
    2315: 'Šmartno na Pohorju',
    3341: 'Šmartno ob Dreti',
    3327: 'Šmartno ob Paki',
    1275: 'Šmartno pri Litiji',
    2383: 'Šmartno pri Slovenj Gradcu',
    3201: 'Šmartno v Rožni dolini',
    3325: 'Šoštanj',
    6222: 'Štanjel',
    3220: 'Štore',
    3304: 'Tabor',
    3221: 'Teharje',
    9251: 'Tišina',
    5220: 'Tolmin',
    3326: 'Topolšica',
    2371: 'Trbonje',
    1420: 'Trbovlje',
    8231: 'Trebelno',
    8210: 'Trebnje',
    5252: 'Trnovo pri Gorici',
    2254: 'Trnovska vas',
    1222: 'Trojane',
    1236: 'Trzin',
    4290: 'Tržič',
    8295: 'Tržišče',
    1311: 'Turjak',
    9224: 'Turnišče',
    8323: 'Uršna sela',
    1252: 'Vače',
    3320: 'Velenje',
    3322: 'Velenje - poštni predali',
    8212: 'Velika Loka',
    2274: 'Velika Nedelja',
    9225: 'Velika Polana',
    1315: 'Velike Lašče',
    8213: 'Veliki Gaber',
    9241: 'Veržej',
    1312: 'Videm - Dobrepolje',
    2284: 'Videm pri Ptuju',
    8344: 'Vinica',
    5271: 'Vipava',
    4212: 'Visoko',
    1294: 'Višnja Gora',
    3205: 'Vitanje',
    2255: 'Vitomarci',
    1217: 'Vodice',
    3212: 'Vojnik',
    5293: 'Volčja Draga',
    2232: 'Voličina',
    3305: 'Vransko',
    6217: 'Vremski Britof',
    1360: 'Vrhnika',
    2365: 'Vuhred',
    2367: 'Vuzenica',
    8292: 'Zabukovje',
    1410: 'Zagorje ob Savi',
    1303: 'Zagradec',
    2283: 'Zavrč',
    8272: 'Zdole',
    4201: 'Zgornja Besnica',
    2242: 'Zgornja Korena',
    2201: 'Zgornja Kungota',
    2316: 'Zgornja Ložnica',
    2314: 'Zgornja Polskava',
    2213: 'Zgornja Velka',
    4247: 'Zgornje Gorje',
    4206: 'Zgornje Jezersko',
    2285: 'Zgornji Leskovec',
    1432: 'Zidani Most',
    3214: 'Zreče',
    4209: 'Žabnica',
    3310: 'Žalec',
    4228: 'Železniki',
    2287: 'Žetale',
    4226: 'Žiri',
    4274: 'Žirovnica',
    8360: 'Žužemberk',
    /*
    3505: 'Celje',
    3600: 'Celje',
    6503: 'Koper',
    6502: 'Koper',
    6504: 'Koper',
    6501: 'Koper',
    6600: 'Koper',
    6200: 'Koper',
    4200: 'Kranj',
    4502: 'Kranj',
    1002: 'Ljubljana',
    1517: 'Ljubljana',
    1505: 'Ljubljana',
    1533: 'Ljubljana',
    1512: 'Ljubljana',
    1524: 'Ljubljana',
    1523: 'Ljubljana',
    1522: 'Ljubljana',
    1510: 'Ljubljana',
    1509: 'Ljubljana',
    1538: 'Ljubljana',
    1516: 'Ljubljana',
    1528: 'Ljubljana',
    1540: 'Ljubljana',
    1504: 'Ljubljana',
    1521: 'Ljubljana',
    1545: 'Ljubljana',
    1542: 'Ljubljana',
    1525: 'Ljubljana',
    1544: 'Ljubljana',
    1514: 'Ljubljana',
    1526: 'Ljubljana',
    1502: 'Ljubljana',
    1501: 'Ljubljana',
    1535: 'Ljubljana',
    1536: 'Ljubljana',
    1537: 'Ljubljana',
    1520: 'Ljubljana',
    1534: 'Ljubljana',
    1503: 'Ljubljana',
    1527: 'Ljubljana',
    1600: 'Ljubljana',
    1550: 'Ljubljana',
    1532: 'Ljubljana',
    1513: 'Ljubljana',
    1511: 'Ljubljana',
    1506: 'Ljubljana',
    1519: 'Ljubljana',
    1543: 'Ljubljana',
    1546: 'Ljubljana',
    1547: 'Ljubljana',
    1518: 'Ljubljana',
    1507: 'Ljubljana',
    1529: 'Ljubljana',
    2002: 'Maribor',
    2502: 'Maribor',
    2509: 'Maribor',
    2506: 'Maribor',
    2505: 'Maribor',
    2503: 'Maribor',
    2508: 'Maribor',
    2500: 'Maribor',
    2600: 'Maribor',
    2607: 'Maribor',
    2609: 'Maribor',
    2610: 'Maribor',
    2501: 'Maribor',
    2504: 'Maribor',
    2507: 'Maribor',
    9501: 'Murska Sobota',
    4501: 'Naklo',
    8501: 'Novo mesto',
    9502: 'Radenci',
    3503: 'Velenje',
    3504: 'Velenje'
*/
  }
}
